// extracted by mini-css-extract-plugin
export default {"wrap":"_F-z","subtitle":"aG-z","contentWrap":"bG-z","imgWrap":"cG-z","heading":"dG-z","copy":"eG-z"};